// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class Countdown extends WebComponent {
  didMount() {
    const {
            countdownTo,
          } = this.props;

    const self = this;

    self.days = this.element.querySelector('.countdown__days');
    self.daysValue = this.days.querySelector('strong');

    self.hours = this.element.querySelector('.countdown__hours');
    self.hoursValue = this.hours.querySelector('strong');
    self.minutes = this.element.querySelector('.countdown__minutes');
    self.minutesValue = this.minutes.querySelector('strong');
    self.seconds = this.element.querySelector('.countdown__seconds');
    self.secondsValue = this.seconds.querySelector('strong');

    const countdownDate = new Date(countdownTo).getTime();
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = countdownDate - now;
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      self.daysValue.innerHTML = days;
      self.hoursValue.innerHTML = hours;
      self.minutesValue.innerHTML = minutes;
      self.secondsValue.innerHTML = seconds;

      if (days == 0) {
        self.days.style.display = 'none';
      }
      if ((hours == 0) && (days == 0)) {
        self.hours.style.display = 'none';
      }
      if ((minutes == 0) && (days == 0) && (hours == 0)) {
        self.minutes.style.display = 'none';
      }
      if ((distance < 0) || ((seconds <= 0) && (minutes == 0) && (days == 0) && (hours == 0))) {
        self.element.classList.add('hidden');
      } else {
        self.element.classList.remove('hidden');
      }

      if (distance < 0) {
        clearInterval(timer);
      }
    }, 1000);
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Countdown.js